
import $axios from '@/plugins/axiosInstance'

// import axios from 'axios';

// axios.defaults.withCredentials = true;

export default {
    // login(item) {
    //   return axiosPure.post('Auth/Login',item);
    // },
    // listMenus() {
    //   return $axios.get('Auth/listMenus');
    // },
        delete(id) {
      return $axios.delete('FormOge/'+id);
    },
    newGuid() {
      return $axios.get('FormOge/newGuid');
    },
    IdVarmi(id){
       return $axios.get('FormOge/IdVarmi/'+id);
    },
        isDeleteValid(id){
       return $axios.get('FormOge/isDeleteValid/'+id);
    }
,
 PasifToggle(id){
       return $axios.get('FormOge/PasifToggle/'+id);
    },
matrixItemsDelete(id){
   return $axios.delete('FormOge/matrixItemsDelete/'+id);
 

},
  matrixItemAktifYap(id){
   return $axios.get('FormOge/MatrixItemAktifYap/'+id);
   }


    //   delete(birim) {
    //     return $axios.delete('/Birim/delete/'+birim.id);
  
    //   }
  };